 import React, { useCallback, useState, useReducer, useEffect } from 'react';
 import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  ButtonBase,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Joi from 'joi';
import { useHistory } from 'react-router';
import { QuickAddContact } from '../../../../../../../../../Services/ContactsServices';
import {
  showError,
  showSuccess,
  getErrorByName,
  GlobalHistory,
} from '../../../../../../../../../Helper';
import {
  emailExpression,
  phoneExpression,
} from '../../../../../../../../../Utils/Expressions';

import { Inputs, Spinner } from '../../../../../../../../../Components';

import {
 TitleComponent, EmailAddressComponent, NationalityComponent, PhoneNumberComponent, DistrictComponent,
           CountryComponent,
           CityComponent,
           CommunityComponent,
           ContactClassComponent,
           LanguageComponent
          } from './Components';
import { useSuccessDialog } from '../../../../../../../../../SharedComponents';
import { useContactValidationContext } from '../../../../../../../../../Contexts/ContactValidationContext/ContactValidationContext';

  export const AddContactDialog = ({
      parentTranslationPath,
      translationPath,
      open,
      close,
    }) => {
      const {
        data: { firstName, lastName, phone, email },
        isValidContact,
      } = useContactValidationContext();
       const { t } = useTranslation([parentTranslationPath]);
       const { showDialog } = useSuccessDialog();
       const [isLoading, setIsLoading] = useState(false);
       const [isSubmitted, setIsSubmitted] = useState(false);
       const [isInValidSalutation, setIsInValidSalutation] = useState(false);
       const history = useHistory();
       const [addressLoadings, setAddressLoadings] = useState({
 country: false, city: false, district: false, community: false
});
       const reducer = useCallback((state, action) => {
        if (action.id !== 'edit'){
          return { ...state, [action.id]: action.value };
        } else {
          return action.value
        }
       }, []);

      const [cityList, setCityList] = useState([]);
      const [districtList, setDistrictList] = useState([]);
      const [communityList, setCommunityList] = useState([]);
      const [state, setState] = useReducer(reducer, {
        contactsTypeId: 1,
        firstName,
        lastName,
        salutationId: '',
        emailAddress: [email],
        phoneNumber: [phone],
        nationalityId: '',
        countryId: 0,
        cityId: 0,
        districtId: 0,
        communityId: 0,
        postalZipCode: '',
        data_completed: 16,
        contactClassId: null,
        languageId: null,
      });

      const [selected, setSelected] = useReducer(reducer, {
            Title: null,
            AssignedTo: null,
            Nationality: null,
            Country: null,
            City: null,
            District: null,
            Community: null,
            Language: null,
            ContactClass: null,
           });

  const schema = Joi.object({
    firstName: Joi.string()
      .required()
      .messages({
        'string.base': t`${translationPath}firstName-is-required`,
        'string.empty': t`${translationPath}firstName-is-required`,
      }),

    lastName: Joi.string()
      .required()
      .messages({
        'string.base': t`${translationPath}lastName-is-required`,
        'string.empty': t`${translationPath}lastName-is-required`,
      }),

    nationalityId: Joi.number()
      .required()
      .messages({
        'number.base': t(`${translationPath}nationality-is-required`),
        'number.empty': t(`${translationPath}nationality-is-required`),
      }),

    languageId: Joi.number()
    .required()
    .messages({
      'number.base': t(`${translationPath}language-is-required`),
      'number.empty': t(`${translationPath}language-is-required`),
    }),

    contactClassId: Joi.number()
    .required()
    .messages({
      'number.base': t(`${translationPath}contact-class-is-required`),
      'number.empty': t(`${translationPath}contact-class-is-required`),
    }),

    emailAddress: Joi.array()
      .items(
        Joi.string().optional().allow('')
          .regex(emailExpression)
          .messages({
            'string.pattern.base': t(`${translationPath}invalid-email`),
          })
      ),
    phoneNumber: Joi.array()
      .items(
        Joi.string()
           .messages({
             'string.pattern.base': t(`${translationPath}invalid-mobile-number`),
             'string.base': t(`${translationPath}phoneNumber-is-required`),
             'string.empty': t(`${translationPath}phoneNumber-is-required`),
          })
      )
      .required()
      .min(1)
      .messages({
        'array.base': t(`${translationPath}phoneNumber-is-required`),
        'array.empty': t(`${translationPath}phoneNumber-is-required`),
        'array.min': t(
          `${translationPath}should-have-a-minimum-one-of-phone-number`
        ),
      }),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate({...state, phoneNumber:[phone], emailAddress: [email]});

  const saveHandler = useCallback(async (isContinue) => {
    setIsLoading(true);
    setIsSubmitted(true);
    if (!state.salutationId)
      setIsInValidSalutation(true);

    if (schema.error || isInValidSalutation) {
      showError(t('Shared:please-fix-all-errors'));
      setIsLoading(false);
      return;
    }
    const result = await QuickAddContact({...state, phoneNumber:[phone], emailAddress: [email]});
    if (!(result && result.data)) {
      if (isContinue)
        history.push(`/home/Contacts-CRM/contact-profile-edit?formType=1&id=${result.contactId}`);
      // showSuccess(t`${translationPath}AddContactSuccessfully`);
      showDialog(t('GlobalSuccessDialog:contact-successfully'), {
        name: `${state.firstName} ${state.lastName}`,
        id: result.contactId,
      });
      close();
    } else showError(
      result?.data?.Message?.split(':')?.[1] ??
      t('Shared:please-fix-all-errors')
    );
    setIsLoading(false);
  }, [schema.error, state]);

    useEffect(() => {
      const newState = {
        ...state,
        firstName,
        lastName,
        phoneNumber: (phone && [phone]) || null,
        emailAddress: (email && [email]) || null,
      };

      setState({
        id: "edit",
        value: newState,
      });
    }, [firstName, lastName, phone, email]);

    useEffect(() => {
      if (!open) {
        setState({
          id: "edit",
          value: {
            contactsTypeId: 1,
            firstName,
            lastName,
            salutationId: "",
            emailAddress: null,
            phoneNumber: null,
            nationalityId: "",
            countryId: 0,
            cityId: 0,
            districtId: 0,
            communityId: 0,
            postalZipCode: "",
            data_completed: 16,
            contactClassId: null,
            languageId: null,
          },
        });
        setSelected({
          id: "edit",
          value: {
            Title: null,
            AssignedTo: null,
            Nationality: null,
            Country: null,
            City: null,
            District: null,
            Community: null,
            Language: null,
            ContactClass: null,
          },
        });
      }
    }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={(_e, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          close();
        }}
        className='activities-management-dialog-wrapper'
      >
        <form noValidate>
          <DialogTitle id='alert-dialog-slide-title'>
            {t(`${translationPath}AddNewcontact`)}
          </DialogTitle>
          <DialogContent>
            <div className='dialog-content-wrapper'>
              <Spinner isActive={isLoading} isAbsolute />
              <div className='title-wrapper'>
                <span className='title-text'>
                  {t(`${translationPath}MainInfo`)}
                </span>
              </div>

              <div className='reminder-wrapper'>
                <div className='reminder-item-wrapper'>
                  <div className='reminder-section-20'>
                    <TitleComponent
                      labelClasses='Requierd-Color'
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      salutationId={state.salutationId}
                      selected={selected}
                      setSelected={(event) => {
                        setSelected({
                          id: 'Title',
                          value: event || null,
                        });
                      }}
                      setSalutationId={(event) => {
                        setState({
                          id: 'salutationId',
                          value: event || null,
                        });
                      }}
                      isSubmitted={isSubmitted}
                      helperText={
                        getErrorByName(schema, 'salutationId').message
                      }
                      error={getErrorByName(schema, 'salutationId').error}
                      isInValidSalutation={isInValidSalutation}
                      setIsInValidSalutation={setIsInValidSalutation}
                    />
                  </div>
                  <div className='reminder-section-30'>
                    <Inputs
                      labelClasses='Requierd-Color'
                      idRef='firstNameRef'
                      labelValue='firstName'
                      value={state.firstName}
                      isWithError
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      onInputChanged={(e) => {
                        setState({
                          id: 'firstName',
                          value: e.target.value || null,
                          });
                      }}
                      isSubmitted={isSubmitted}
                      helperText={getErrorByName(schema, 'firstName').message}
                      error={getErrorByName(schema, 'firstName').error}
                      isDisabled={isValidContact}
                    />
                  </div>
                  <div className='reminder-section-50'>
                    <Inputs
                      value={state.lastName}
                      idRef='lastNameRef'
                      labelClasses='Requierd-Color'
                      labelValue='lastName'
                      isWithError
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      onInputChanged={(e) => {
                        setState({
                          id: 'lastName',
                          value: e.target.value || null,
                        });
                      }}
                      isDisabled={isValidContact}
                      isSubmitted={isSubmitted}
                      helperText={getErrorByName(schema, 'lastName').message}
                      error={getErrorByName(schema, 'lastName').error}
                    />
                  </div>
                </div>
              </div>

              <div className='dialog-content-item'>
                <PhoneNumberComponent
                  labelClasses='Requierd-Color'
                  phoneNumber={state.phoneNumber}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  setPhone={(event) => {
                    setState({ id: 'phoneNumber', value: event || null });
                  }}
                  isSubmitted={isSubmitted}
                  helperText={getErrorByName(schema, 'phoneNumber').message}
                  error={getErrorByName(schema, 'phoneNumber').error}
                />
              </div>

              <div className='dialog-content-item'>
                <EmailAddressComponent
                  emailAddress={state.emailAddress}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  setEmail={(event) => {
                    // setState({ id: 'emailAddress', value: event || null });
                  }}
                  isSubmitted={isSubmitted}
                  helperText={getErrorByName(schema, 'emailAddress').message}
                  error={getErrorByName(schema, 'emailAddress').error}
                  isDisabled={isValidContact}
                />
              </div>

              <div className='dialog-content-item'>
                <NationalityComponent
                  labelClasses='Requierd-Color'
                  nationalityId={state.nationalityId}
                  selected={selected}
                  setSelected={(event) => {
                    setSelected({
                      id: 'Nationality',
                      value: event || null,
                    });
                  }}
                  setNationalityId={(event) => {
                    setState({ id: 'nationalityId', value: event || null });
                  }}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  isSubmitted={isSubmitted}
                  helperText={getErrorByName(schema, 'nationalityId').message}
                  error={getErrorByName(schema, 'nationalityId').error}
                />
              </div>
              <div className='dialog-content-item'>
                <LanguageComponent
                  state={state}
                  selected={selected}
                  setSelected={(event) => {
                    setSelected({
                      id: 'Language',
                      value: event || null,
                    });

                    setState({ id: 'languageId', value: (event && event.lookupItemId) || null });
                  }}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  schema={schema}
                  isSubmitted={isSubmitted}
                />
              </div>
              <div className='dialog-content-item'>
                <ContactClassComponent
                  state={state}
                  selected={selected}
                  setSelected={(event) => {
                    setSelected({
                      id: 'ContactClass',
                      value: event || null,
                    });

                    setState({ id: 'contactClassId', value: (event && event.lookupItemId) || null });
                  }}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  schema={schema}
                  isSubmitted={isSubmitted}
                />
              </div>

              <div className='title-wrapper'>
                <span className='title-text'>
                  {t(`${translationPath}Address`)}
                </span>
              </div>

              <div className='dialog-content-item'>
                <CountryComponent
                  countryId={state.countryId}
                  selected={selected}
                  addressLoadings={addressLoadings}
                  setAddressLoadings={setAddressLoadings}
                  setSelected={(event) => {
                    setSelected({
                      id: 'Country',
                      value: event || null,
                    });
                    setSelected({
                      id: 'City',
                      value: null,
                    });
                    setSelected({
                      id: 'District',
                      value: null,
                    });
                    setSelected({
                      id: 'Community',
                      value: null,
                    });
                    setCityList([]);
                    setDistrictList([]);
                    setCommunityList([]);
                  }}
                  setCountryId={(event) => {
                    setState({ id: 'countryId', value: event });
                    setState({ id: 'cityId', value: null });
                    setState({ id: 'districtId', value: null });
                    setState({ id: 'communityId', value: null });
                  }}
                  setCityList={setCityList}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                />
              </div>

              <div className='dialog-content-item'>
                <CityComponent
                  cityId={state.cityId}
                  cityList={cityList && cityList.length > 0 ? cityList : []}
                  addressLoadings={addressLoadings}
                  setAddressLoadings={setAddressLoadings}
                  selected={selected}
                  setSelected={(event) => {
                    setSelected({
                      id: 'City',
                      value: event || null,
                    });
                    setSelected({
                      id: 'District',
                      value: null,
                    });
                    setSelected({
                      id: 'Community',
                      value: null,
                    });
                    setDistrictList([]);
                    setCommunityList([]);
                  }}
                  setCityId={(event) => {
                    setState({ id: 'cityId', value: event });
                    setState({ id: 'districtId', value: null });
                    setState({ id: 'communityId', value: null });
                  }}
                  setDistrictList={setDistrictList}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                />
              </div>

              <div className='dialog-content-item'>
                <DistrictComponent
                  districtId={state.districtId}
                  selected={selected}
                  addressLoadings={addressLoadings}
                  setAddressLoadings={setAddressLoadings}
                  districtList={
                    districtList && districtList.length > 0 ? districtList : []
                  }
                  setSelected={(event) => {
                    setSelected({
                      id: 'District',
                      value: event,
                    });
                    setSelected({
                      id: 'Community',
                      value: null,
                    });
                    setCommunityList([]);
                  }}
                  setDistrictId={(event) => {
                    setState({ id: 'districtId', value: event || null });
                    setState({ id: 'communityId', value: null });
                  }}
                  setCommunityList={setCommunityList}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                />
              </div>

              <div className='dialog-content-item'>
                <CommunityComponent
                  communityId={state.communityId}
                  addressLoadings={addressLoadings}
                  setAddressLoadings={setAddressLoadings}
                  selected={selected}
                  communityList={
                    communityList && communityList.length > 0 ?
                      communityList :
                      []
                  }
                  setSelected={(event) => {
                    setSelected({
                      id: 'Community',
                      value: event || null,
                    });
                  }}
                  setCommunityId={(event) => {
                    setState({ id: 'communityId', value: event || null });
                  }}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className='form-builder-wrapper'>
              <div className='form-builder-footer-wrapper is-dialog w-100 MuiGrid-align-items-xs-center MuiGrid-justify-xs-space-between'>
                <div className='MuiGrid-root-left'>
                  <ButtonBase
                    className='MuiButtonBase-root MuiButton-root MuiButton-text btns c-danger'
                    onClick={() => close()}
                  >
                    <span className='MuiButton-label'>
                      <span className='mx-2'>
                        {t(`${translationPath}cancel`)}
                      </span>
                    </span>
                    <span className='MuiTouchRipple-root' />
                  </ButtonBase>
                </div>
                <div className='MuiGrid-root-right'>
                  <ButtonBase
                    className='MuiButtonBase-root MuiButton-root MuiButton-text btns'
                    onClick={() => {
                      close();
                      GlobalHistory.push('/home/Contacts-CRM/add?formType=1');
                    }}
                  >
                    <span className='MuiButton-label'>
                      <span className='mx-2'>
                        {t(`${translationPath}openFullContactView`)}
                      </span>
                    </span>
                    <span className='MuiTouchRipple-root' />
                  </ButtonBase>

                  <ButtonBase
                    className='MuiButtonBase-root MuiButton-root MuiButton-text btns'
                    onClick={() => saveHandler(true)}
                  >
                    <span className='MuiButton-label'>
                      <span className='mx-2'>
                        {t(`${translationPath}Save and Continue`)}
                      </span>
                    </span>
                    <span className='MuiTouchRipple-root' />
                  </ButtonBase>
                  <ButtonBase
                    className='MuiButtonBase-root MuiButton-root MuiButton-text btns theme-solid bg-primary'
                    id='Submit-bbt'
                    onClick={() => saveHandler()}
                  >
                    <span className='MuiButton-label'>
                      <span className='mx-2'>
                        {t(`${translationPath}save`)}
                      </span>
                    </span>
                    <span className='MuiTouchRipple-root' />
                  </ButtonBase>
                </div>
              </div>
            </div>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};
